import { useOnline } from '@/components/ClusterBits'
import { HostsList, loadHosts } from '@/components/Hosts'
import { AppTabs, INFRA_TABS } from '@/components/AppTabs'
import { PageTitle } from '@/components/ui'

/**
 * Hosts, the infra pack's second page (/infra/hosts, 2026-10-31): every
 * machine the owner runs, grouped by estate, from GET /api/hosts
 * (internal/hosts; components/Hosts.tsx draws it). Online only; refreshed every
 * 30 s while it shows, as the server's copy is.
 */
export const InfraHostsView = () => {
  const hosts = useOnline(loadHosts, 30_000)
  return (
    <div className="max-w-2xl" data-testid="infra-hosts-page">
      <PageTitle>Hosts</PageTitle>
      <AppTabs tabs={INFRA_TABS} label="Infrastructure" />
      <HostsList {...hosts} />
    </div>
  )
}
